import React from 'react';
import Calculator from '~components/Calculator';
import { Query } from '~api/get/getObjects';
import CalculatorRenderProps, {
  Props as CalculatorRenderPropsProps,
} from '~utils/renderProps/CalculatorRenderProps';
import { URLS } from '~src/api/urls';
import styles from './styles.module.css';

type Props = Pick<CalculatorRenderPropsProps, 'config'>;

const OfficeCalculator = ({ config }: Props) => (
  <CalculatorRenderProps config={config}>
    {(calculatorProps) => {
      const {
        data: { sales, rents, items },
        getQuery,
      } = calculatorProps;

      const query = getQuery();

      const saleQuery: Query = { ...query, typeListing: 'sale' };

      const rentQuery: Query = { ...query, typeListing: 'rent' };

      return (
        <div>
          <div className={styles['calculator__body']}>
            <div className={styles['calculator__bg']}>
              <div className='container'>
                <Calculator {...calculatorProps} />
              </div>
            </div>
          </div>
          <div className='container'>
            <div className={styles['calculator-results']}>
              {items.length ? (
                <>
                  <span className={styles['calculator-results__title']}>
                    Подходящие предложения:
                  </span>
                  <div className={styles['calculator-results__buttons']}>
                    {!!Number(sales) && (
                      <a
                        href={URLS.old.getSearchUrl(saleQuery)}
                        className={[
                          'button',
                          styles['calculator-results__button'],
                        ].join(' ')}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <span>{`Офисы на продажу (${sales})`}</span>
                      </a>
                    )}
                    {!!Number(rents) && (
                      <a
                        href={URLS.old.getSearchUrl(rentQuery)}
                        className={[
                          'button',
                          styles['calculator-results__button'],
                        ].join(' ')}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <span>{`Офисы в аренду (${rents})`}</span>
                      </a>
                    )}
                  </div>
                </>
              ) : (
                <span className={styles['calculator-results__title']}>
                  Предложений не найдено.
                </span>
              )}
            </div>
          </div>
        </div>
      );
    }}
  </CalculatorRenderProps>
);

export default OfficeCalculator;
